var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError400(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1749 38.9998L35.6858 52.9385L51.3402 32.9998H35.8239L37.3107 19.0982L21.6877 38.9998H37.1749ZM44.3882 9.34277C44.7087 6.3464 40.9062 4.80095 39.0455 7.1713L13.159 40.1473C11.6136 42.1159 13.0161 44.9998 15.5188 44.9998H30.4998L28.6098 62.6911C28.2897 65.6872 32.0917 67.2324 33.9524 64.8624L59.8693 31.8524C61.4149 29.8838 60.0125 26.9998 57.5097 26.9998H42.4998L44.3882 9.34277Z",
    fill: "#FF794D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError400);
export default __webpack_public_path__ + "static/media/error_400.5b19e6af2f9b27dfcb587d827a455c21.svg";
export { ForwardRef as ReactComponent };